import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

ReactDOM.render(<App />, document.getElementById("root"));
